//

import { normalize } from 'normalizr';
import moment from 'moment';

import { simplApi } from '../../api/simplApi';

import { serviceKey } from './schemas';
import { dateFormat } from '../../helpers/formats';
import { receiveServiceType } from './servicetype';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_SERVICEKEY = 'REQUEST_SERVICEKEY';
export const RECEIVE_SERVICEKEY = 'RECEIVE_SERVICEKEY';
export const SET_SERVICEKEY = 'SET_SERVICEKEY';
export const SET_SERVICEKEY_FORM = 'SET_SERVICEKEY_FORM';
export const CLOSE_SERVICEKEY_FORM = 'CLOSE_SERVICEKEY_FORM';
export const REMOVE_SERVICEKEY = 'REMOVE_SERVICEKEY';

// ------------------------------------
// Actions
// ------------------------------------

export function requestServiceKey() {
  return {
    type: REQUEST_SERVICEKEY,
  };
}

export function receiveServiceKey(serviceKeys) {
  return {
    type: RECEIVE_SERVICEKEY,
    payload: {
      serviceKeys,
    },
  };
}

export function setServiceKey(serviceKeyId) {
  // console.log('action setServiceKey', serviceKeyId);
  return {
    type: SET_SERVICEKEY,
    payload: serviceKeyId,
  };
}

export function setServiceKeyForm(serviceKeyId = '') {
  return {
    type: SET_SERVICEKEY_FORM,
    payload: serviceKeyId,
  };
}

export function closeServiceKeyForm() {
  return {
    type: CLOSE_SERVICEKEY_FORM,
  };
}

export const fetchServiceKey = serviceKeyId => dispatch => {
  dispatch(requestServiceKey());

  const url =
    typeof serviceKeyId !== 'undefined' && serviceKeyId !== null
      ? `serviceKey/${serviceKeyId}`
      : 'serviceKey';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedServiceKeys;

        if (typeof json.id === 'undefined') {
          preparedServiceKeys = normalize(json, [serviceKey]);
        } else {
          preparedServiceKeys = normalize(json, serviceKey);
        }

        // // console.log('prepping json', json, preparedServiceKeys);

        dispatch(receiveServiceKey(preparedServiceKeys.entities.serviceKeys));
        dispatch(receiveServiceType(preparedServiceKeys.entities.serviceTypes));
      }
    });
};

export function removeServiceKey(serviceKeyId) {
  return {
    type: REMOVE_SERVICEKEY,
    payload: serviceKeyId,
  };
}

export const deleteServiceKey = serviceKeyId => dispatch => {
  const url = `serviceKey/${serviceKeyId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removeServiceKey(serviceKeyId));
      }
    });
};

export const saveServiceKey = newServiceKey => dispatch => {
  // console.log('attempting to save an serviceKey!', newServiceKey);

  dispatch(requestServiceKey());

  let url = 'serviceKey/';
  const options = { method: 'post', body: newServiceKey };
  if (typeof newServiceKey.id !== 'undefined' && newServiceKey.id !== null) {
    url = `${url}${newServiceKey.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        const preparedServiceKeys = normalize(json, serviceKey);

        // console.log('prepping json', json, preparedServiceKeys);

        dispatch(receiveServiceKey(preparedServiceKeys.entities.serviceKeys));
        dispatch(receiveServiceType(preparedServiceKeys.entities.serviceTypes));
        dispatch(fetchTotalData());
      }
    });
};

export const actions = {
  requestServiceKey,
  receiveServiceKey,
  fetchServiceKey,
  setServiceKey,
  setServiceKeyForm,
  closeServiceKeyForm,
  saveServiceKey,
  deleteServiceKey,
  removeServiceKey,
};

const SERVICEKEY_ACTION_HANDLERS = {
  [REQUEST_SERVICEKEY]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_SERVICEKEY]: (state, action) => ({ ...state, current: action.payload }),
  [SET_SERVICEKEY_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_SERVICEKEY]: (state, action) => ({
    ...state,
    serviceKeys: _.omit(state.serviceKeys, action.payload),
  }),
  [CLOSE_SERVICEKEY_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_SERVICEKEY]: (state, action) => {
    const stateServiceKeys = state.serviceKeys;

    _.forOwn(action.payload.serviceKeys, (_serviceKey, id) => {
      const newServiceKey = _serviceKey;
      const newMeta = {};

      _.forOwn(_serviceKey.meta, value => {
        newMeta[value.key] = value;
      });

      newServiceKey.meta = newMeta;

      newServiceKey.createdDate = moment(_serviceKey.created_at).format(
        dateFormat,
      );

      if (typeof stateServiceKeys[id] === 'object') {
        Object.assign(
          stateServiceKeys[id],
          stateServiceKeys[id],
          newServiceKey,
        );
      } else {
        stateServiceKeys[id] = newServiceKey;
      }
    });

    return {
      ...state,
      serviceKeys: stateServiceKeys,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  current: null,
  formOpen: false,
  formTarget: null,
  fetching: false,
  serviceKeys: {},
};
export default function serviceKeyReducer(state = initialState, action) {
  const handler = SERVICEKEY_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/servicekey.js